import React, {useEffect, useRef, useState} from "react";
import "./PrintType7.scss";
import commaSeparator, {
  formatToPersianAddComma,
} from "../../../utils/CommaSeparator";
import numericFunction from "../../../utils/NumericFunction";
import NumericFunction from "../../../utils/NumericFunction";
import Barcode from "react-barcode";
import PrintType7Header from "./PrintType7Header";
import PrintType7Footer from "./PrintType7Footer";
import PrintType7Header2 from "./PrintType7Header";
import PrintType7Footer2 from "./PrintType7Footer";

const PrintType7 = ({data}) => {
  debugger
  let addRowToPrint = false
  let totalClassName = "printType7";
  let style = ``;

  //  ارتفاع پرینت دقیقا باید برابر باشه به همون قدری که محتوا توشه با رف اینو گرفتم
  const ref = useRef();
  const [totalHeight, setTotalHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      debugger;
      setTotalHeight(ref.current.offsetHeight);
    }
  }, [ref.current]);

  //////////////////

  style = `
    @page {
      size: A4;
      padding: 0.5cm !important; 
      margin: 0.5cm !important;
    }
  `;
  if(data.entityName==="TASKOL"){
    debugger
    addRowToPrint = true
  }
  if (data.entityName === "FAKKOLSELL" && data.sellFactorPrintSize === "8cm") {
    totalClassName = "bill8cmPrint";
    style = `
      @media print{
        @page {
          size: 8cm ${totalHeight + 30}px !important;
          margin: 0.25m;
        }
      }
  `;
  }

  let myColumns: [] = data && data.data[0] && data.data[0].column ? data.data[0].column : [];
  let myData: [] = data && data.data[0] && data.data[0].data ? data.data[0].data : [];
  let fieldColumns: string[] = [];

  myColumns.forEach((myColumn) => {
    fieldColumns.push(myColumn.field);
  });

  let currency: string, title: string, factorId: String, textUnderPrint: string, bedSum: number, besSum: number;

  title = data.title;
  factorId = data.factorId;
  textUnderPrint = data.textUnderPrint;
  bedSum = data && data.data[0] && data.data[0].bedSum ? formatToPersianAddComma(data.data[0].bedSum) : "";
  besSum = data && data.data[0] && data.data[0].besSum ? formatToPersianAddComma(data.data[0].besSum) : "";
  currency = data && data.data[0] && data.data[0].currency ? data.data[0].currency : "";

  try {
    return (<div ref={ref} className={"myPrintType7TotalCssClass"}>
      <style>{style}</style>
      <div className={totalClassName}>
        <div className={"d-flex justify-content-between my-1"}>
          <div>{title}</div>
          <div>
            {factorId && (<>
              <Barcode
                value={factorId}
                height={30}
                // height={12}
                format={"CODE128B"}
                width={1.3}
                // width={12}
                fontSize={10}
                margin={0}
                displayValue={false}
              />
              <div>
                <small>کد: {numericFunction.e2p(factorId)} </small>
              </div>
            </>)}
          </div>
        </div>
        <table>
          <thead>
          <tr>
            <td colSpan={myColumns.length + (addRowToPrint ? 1 : 0)}>
              <PrintType7Header data={data}/>
              {/*<div className={""}>*/}

              {/*  <div className={"d-flex flex-wrap w-100 headerPrintType7 text-end"}>*/}
              {/*    <div style={{flex: '80%'}} className={"d-flex flex-wrap w-100 text-end"}>*/}
              {/*      /!*<div>{dateLabel}: {date}</div>*!/*/}
              {/*      /!*<div>{timeLabel}: {time}</div>*!/*/}
              {/*      /!*<div>{userLabel}: {user}</div>*!/*/}
              {/*      {data.headerAndFooter.header.map((v, index) => {*/}
              {/*        if (v.id === 'Memo100') {*/}
              {/*          return null*/}
              {/*        }*/}
              {/*        return <div*/}
              {/*          className={"mx-3"}*/}
              {/*          // style={{flex: (50 / data.headerAndFooter.header.lenght)}}*/}
              {/*          style={v.style ? v.style : {}}*/}
              {/*        >{v.label}: {NumericFunction.e2p(v.value)}</div>*/}
              {/*      })}*/}

              {/*      /!*</div>*!/*/}
              {/*      /!*<div>*!/*/}
              {/*      /!*  <div>{nameLabel}: {name}</div>*!/*/}
              {/*      /!*  <div>{formNameLabel}: {formName}</div>*!/*/}

              {/*    </div>*/}
              {/*    <div style={{flex: '19%'}} className={"imgParent"}>{logoUrl && <img src={logoUrl} alt={''}/>}</div>*/}

              {/*  </div>*/}
              {/*</div>*/}
            </td>
          </tr>

          <tr>
            {addRowToPrint && <td>{"ردیف"}</td>}
            {myColumns?.map((v, index) => (<td key={"R" + index}>{v.title}</td>))}
          </tr>
          </thead>

          <tbody>
          {myData.map((singleRowData, index) => (<><tr id={singleRowData.id} key={"R" + index}>
            {addRowToPrint && <td>{numericFunction.e2p(index + 1)}</td>}
            {fieldColumns.map((field, indexField: number) => {
              //اگه کد کالا بود سه رقم جدا نشه کلید CKALA
              if (singleRowData[field] === "" || field === "CKALA" || field === "row") {
                return (<td key={indexField}>
                  {numericFunction.e2p(singleRowData[field]) + ""}
                </td>);
              } else {
                return (<td key={indexField}>
                  {/*{(numericFunction.e2p(singleRowData[field] + ""))}*/}
                  {!isNaN(+singleRowData[field]) ? (+singleRowData[field])?.toLocaleString() : singleRowData[field] }

                  {/*{singleRowData[field]}*/}
                </td>);
              }
            })}
          </tr></>))}
          </tbody>
          <tfoot>
          <tr>
            <td colSpan={myColumns.length + (addRowToPrint ? 1 : 0)}>
              <PrintType7Footer data={data}/>
            </td>
          </tr>
          <tr>
            <td colSpan={myColumns.length + (addRowToPrint ? 1 : 0)}>
              <div className={"p-2"}>{textUnderPrint}</div>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>);
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default PrintType7;
